import { RecStopEntry } from "../RecStopEntry";
import { YSplitStopsTableRecurringOrder } from "../YSplitStopsTableRecurringOrder";
import { DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutYSplitRecurringOrder extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelExplanationOne: Label;
    labelStops: Label;
    layoutRecStopEntry: RecStopEntry;
    layoutYSplitStopsTableRecurringOrder: YSplitStopsTableRecurringOrder;
    panelStopEntry: Panel;
    panelYSplitStopTable: Panel;
    sourceStopRecOrder: DataSource;
    tabCreateYSplit: Tab;
    tabsetYSplitRecurringOrder: Tabset;
}
